import React from 'react';

// Components
import ComparisonBaseCell from '@/views/containers/comparison/ComparisonTable/ComparisonBaseCell';
import { formatMessage } from '@/utils/i18n';

interface LabelConfig {
  key: string;
  label: string;
  className?: string;
}

interface Props {
  labels: LabelConfig[];
}

const InstrumentComparisonLabels: React.FC<Props> = ({ labels }) => (
  <div className="instrument-comparison-table-labels">
    <ComparisonBaseCell className="instrument-comparison-category-header">
      <span className="label-container">
        <span className="label">{formatMessage('FundDetails.ComparisonTable.KeyMetrics')}</span>
      </span>
    </ComparisonBaseCell>
    {labels.map(labelConfig => (
      <ComparisonBaseCell key={labelConfig.key} className={['comparison-table-cell', labelConfig.className].filter(Boolean).join(' ')}>
        <span className="label-container">
          <span className="label">{labelConfig.label}</span>
        </span>
      </ComparisonBaseCell>
    ))}
  </div>
);

export default InstrumentComparisonLabels;
